import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { login as loginApi, getUserInfo } from '@/services/auth'

// 用户状态管理
export const useUserStore = defineStore('user', () => {
  // State
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref(null)
  const permissions = ref([])

  // Getters
  const isLoggedIn = computed(() => !!token.value)
  const username = computed(() => userInfo.value?.username || '')
  const avatar = computed(() => userInfo.value?.avatar || '')

  // Actions
  // 登录
  async function login(credentials) {
    try {
      const res = await loginApi({
        username: String(credentials.username || ''),
        password: String(credentials.password || '')
      })
      if (res.code === 'SUCCESS') {
        token.value = res.data.token
        userInfo.value = res.data.user
        permissions.value = res.data.permissions || []
        localStorage.setItem('token', res.data.token)
        return { success: true }
      }
      return { success: false, message: res.message }
    } catch (error) {
      return { success: false, message: error.message }
    }
  }

  // 获取用户信息
  async function fetchUserInfo() {
    try {
      const res = await getUserInfo()
      if (res.code === 'SUCCESS') {
        userInfo.value = res.data
        permissions.value = res.data.permissions || []
        return { success: true }
      }
      return { success: false, message: res.message }
    } catch (error) {
      return { success: false, message: error.message }
    }
  }

  // 退出登录
  function logout() {
    token.value = ''
    userInfo.value = null
    permissions.value = []
    localStorage.removeItem('token')
  }

  // 检查权限
  function hasPermission(permission) {
    return permissions.value.includes(permission)
  }

  return {
    token,
    userInfo,
    permissions,
    isLoggedIn,
    username,
    avatar,
    login,
    fetchUserInfo,
    logout,
    hasPermission
  }
})
